"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateMeetingServiceActionSchema () {
        return CreateMeetingServiceActionSchema;
    },
    get MeetingCalendarOperation () {
        return MeetingCalendarOperation;
    },
    get MeetingExtendedModel () {
        return MeetingExtendedModel;
    },
    get MeetingModel () {
        return MeetingModel;
    },
    get UpcomingMeetingModel () {
        return UpcomingMeetingModel;
    },
    get UpdateMeetingServiceActionSchema () {
        return UpdateMeetingServiceActionSchema;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _calendarevent = require("../calendar-event");
const _base = require("./base");
const MeetingModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    meetingWorkspaceId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    description: _zod.z.string(),
    status: _models.MeetingStatusSchema,
    startDateTime: _utilsisomorphic.transformDate,
    endDateTime: _utilsisomorphic.transformDate,
    participants: _zod.z.union([
        _zod.z.array(_base.UserParticipantRecordExtended),
        _zod.z.array(_base.UserParticipantRecord)
    ]),
    calendarEvent: _calendarevent.CalendarEventServiceOptionalSchema,
    created: _base.UserActionRecord,
    updated: _base.UserActionRecord,
    agendaItemCount: _zod.z.number().optional(),
    actionItemCount: _zod.z.number().optional()
});
const MeetingExtendedModel = MeetingModel.extend({
    meetingWorkspaceName: _zod.z.string()
});
const CreateMeetingServiceActionSchema = _models.MeetingsSchema.pick({
    name: true,
    description: true,
    start_date_time: true,
    end_date_time: true,
    participants: true
}).extend({
    add_to_calendar: _zod.z.boolean().optional()
});
const UpdateMeetingServiceActionSchema = _models.MeetingsSchema.pick({
    name: true,
    description: true,
    status: true,
    start_date_time: true,
    end_date_time: true,
    calendar_event: true,
    updated: true
}).partial();
const MeetingCalendarOperation = _zod.z.enum([
    "created",
    "updated",
    "calendar_event_not_found"
]).optional();
const UpcomingMeetingModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    meetingWorkspaceId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    startDateTime: _utilsisomorphic.transformDate,
    endDateTime: _utilsisomorphic.transformDate
});
